import React from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export interface PartsListItems {
    uuid?: string;
    description: string;
    value: string;
    image: string;
    url: string;
    condition?: string;
}
export interface PartsListInterface {
    products: PartsListItems[];
}

export const PartsListContent: React.FC<PartsListInterface> = ({ products }) => {
    const navigate = useNavigate();
    const { t } = useTranslation('core');

    const prepareDescription = (text) => {
        return text.length > 35 ? text.substring(0, 35) + "..." : text;
    };

    const handleItem = (url: string) => {
        navigate(`/product/${url}`);
    }

    return (
        <Row>
            {products.map((product: PartsListItems, index) => (
                <Col
                    key={index}
                    xs={6}
                    sm={4}
                    md={3}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className="text-capitalize p-3 mt-3 hover-primary"
                    onClick={() => handleItem(product.url)}
                    style={{ borderRadius: 10 }}
                >
                    <Row style={{ height: 215, overflow: "hidden" }}>
                        <Col>
                            <img className="d-block w-100" src={product.image} alt="" />
                            <Badge pill bg={product.condition === "PRODUCT_NEW" ? "primary" : "secondary"} className="font-poppins">{t(product.condition ? product.condition : "")}</Badge>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12">
                            {prepareDescription(product.description)}
                        </Col>
                        <Col className="color-secondary fw-bold">R$ {product.value}</Col>
                    </Row>
                </Col>
            ))}
        </Row>
    );
}
